import { all, fork } from 'redux-saga/effects'

import onGetSubscriptionState from './onGetSubscriptionState'
import onSubscribePush from './onSubscribePush'
import initOneSignal from './initOneSignal'
import onCommitOrDidPreviousActivitiesSaga from './onCommitOrDidPreviousActivitiesSaga'

export function* localSettingsSaga() {
  yield all([
    fork(onGetSubscriptionState),
    fork(onSubscribePush),
    fork(initOneSignal),
    fork(onCommitOrDidPreviousActivitiesSaga),
  ])
}
